/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import React from 'react';
import {StyleProp, View, ViewStyle, Platform} from 'react-native';
import { buttonsStyles } from '../../../components/Button/boutonStyle';
import PrimaryButton from '../../../components/Button/PrimaryButton';

interface Props {
  active?: string | boolean;
  callBack: Function;
  label1?: string;
  value1?: string | boolean;
  label2?: string;
  value2?: string | boolean;
  style?: StyleProp<ViewStyle>;
  type?: 'switch' | 'tab'
}
export default function DeclarerSuiviMenu({
  active,
  callBack,
  label1 = 'Déclarer un sinistre ',
  label2 = 'Suivre un sinistre',
  value1 = 'Declarer',
  value2 = 'Suivre',
  style = {},
  type = 'tab',
}: Props) {
  return (
    <View style={[buttonsStyles.btnTabWrapper, style, type === 'switch' ? Platform.OS !== 'web' ? {width: 120, flex: 0} : {maxWidth: 250} : {}]}>
      <PrimaryButton
        onPress={() => callBack(value1)}
        styleBtnTxt={[
          buttonsStyles.btnTabTxt,
          active === value1 && buttonsStyles.btnTabTxtActive,
        ]}
        styleBtnOuter={[
          buttonsStyles.btnTabOuter,
          active === value1 && buttonsStyles.btnTabOuterActive,
          type === 'switch' && Platform.OS !== 'web'  ? {minWidth: 20, width: 60} : {}
        ]}
        title={label1}
      />
      <PrimaryButton
        onPress={() => callBack(value2)}
        styleBtnTxt={[
          buttonsStyles.btnTabTxt,
          active === value2 && buttonsStyles.btnTabTxtActive,
        ]}
        styleBtnOuter={[
          buttonsStyles.btnTabOuter,
          active === value2 && buttonsStyles.btnTabOuterActive,
          type === 'switch' && Platform.OS !== 'web'  ? {minWidth: 20, width: 60} : {}
        ]}
        title={label2}
      />
    </View>
  );
}
